'use strict';
/**
 * Created by MRQ on 2016/1/8.
 */
angular.module('mangeProChannelCtrlModule', [])
    .controller('channelDeleteCtrl', ['$scope', '$modalInstance', 'item', 'successFn', 'productMangageMentWebsiteService', function($scope, $modalInstance, item, successFn, productMangageMentWebsiteService) {
        init();
        $scope.cancel = function() {
            $scope.$close();
        };
        $scope.confirm = function() {
            $modalInstance.close({});
        };
        $scope.deleteToggle = function() {
            $scope.isDeleteFirst = true;
        };

        function init() {
            $scope.item = item;
            $scope.isDeleteFirst = false;
        }
    }])
    .controller('channelModifyCtrl', ['$scope', '$stateParams', '$modalInstance', '$modal', '$validation', 'column', 'successFn', 'initManageConSelectedService', 'productMangageMentWebsiteService', 'websiteChannel', 'trsHttpService', 'modalDialog', function($scope, $stateParams, $modalInstance, $modal, $validation, column, successFn, initManageConSelectedService, productMangageMentWebsiteService, websiteChannel, trsHttpService, modalDialog) {
        initStatus();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [abc description]给周林讲解
         * @param  {[str]} title [description]标题
         * @param  {[str]} text  [description]正文
         * @return {[type]}       [description]null
         */
        function abc(title, text) {

        }

        $scope.confirm = function() {
            $validation.validate($scope.createChlForm).success(function() {
                if ($scope.isChnlExist == '"true"') {
                    modalDialog.alertType('栏目唯一标识已经存在', '', 'error', false);
                    return;
                }
                if ($scope.savePos == 'false') {
                    modalDialog.alertType('存放位置已存在', '', 'error', false);
                    return;
                }
                $scope.channel.CHNLORDER = $scope.selectedWebChannel.value;
                $scope.channel.OutLinePicSize = $scope.picWidth + ',' + $scope.picHeight;
                $modalInstance.close($scope.channel);
            }).error(function() {
                $scope.showAllTips = true;
            });
        };
        //检测存放位置
        $scope.examinePos = function() {
            $scope.isShowTipsSiteName = false;
            var posParams = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'checkChannelPath',
                Siteid: $stateParams.site,
                ChannelId: $scope.channel.OBJECTID,
                DataPath: $scope.channel.DATAPATH,
                ParentId: '0',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), posParams, 'get').then(function(data) {
                $scope.savePos = data;
            });
        };
        /**
         * [checkTempName description] 校验唯一标识是否已经存在
         * @return {[type]} [description]
         */
        $scope.checkIdentify = function() {
            if ($scope.channel.CHNLNAME == $scope.thisChnlName || $scope.channel.CHNLNAME === '') {
                $scope.isChnlExist = false;
                return;
            }
            var params = {
                serviceid: 'mlf_appconfig',
                methodname: 'checkChannelNameExists',
                CHNLNAME: $scope.channel.CHNLNAME,
                SITEID: $stateParams.site,
                CHANNELID: $scope.thisChnlId || '0',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.isChnlExist = data;
            });
        };

        function initEditData() {
            $scope.params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'findChannelById',
                TopChannelId: '0',
                ChannelId: websiteChannel.CHANNELID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                resetSize(data.PICSIZE.OutLinePicSize);
                $scope.channel = {
                    OBJECTID: data.CHANNELID,
                    SITEID: $stateParams.site,
                    CHNLNAME: data.CHNLNAME,
                    CHNLDESC: data.CHNLDESC,
                    PARENTID: data.PARENTID,
                    CHNLORDER: -1,
                    DATAPATH: data.DATAPATH,
                    ROOTDOMAIN: data.ROOTDOMAIN,
                    TEMPID: {
                        CHNLTEMPID: 0,
                        OTHERTEMPID: 0,
                        DOCTEMPID: 0,
                    },
                    OutLinePicSize: $scope.picWidth + ',' + $scope.picHeight,
                };
                if (!$scope.column.isColumn) { //频道 需要图片域名
                    $scope.channel.IMGADDRESS = data.IMGADDRESS;
                }
                $scope.thisChnlName = data.CHNLNAME;
                $scope.thisChnlId = data.CHANNELID;
                $scope.channel.TEMPID.CHNLTEMPID = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPID : '0';
                $scope.channel.TEMPID.OTHERTEMPID = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPID : '0';
                $scope.channel.TEMPID.DOCTEMPID = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPID : '0';
                $scope.tempName.channelTempName = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPNAME : '';
                $scope.tempName.otherTempName = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPNAME : '';
                $scope.tempName.articleTempName = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPNAME : '';
                var i = 0;
                while (i < $scope.websiteChannelsJson.length) {
                    if ($scope.websiteChannelsJson[i].value === data.CHNLORDER) {
                        $scope.websiteChannelsJson.splice(i, 1);
                        $scope.selectedWebChannel = angular.copy($scope.websiteChannelsJson[i - 1]);
                    } else {
                        i++;
                    }
                }
            });
        }

        function initStatus() {
            $scope.channel = {
                OBJECTID: 0,
                SITEID: $stateParams.site,
                CHNLNAME: '',
                CHNLDESC: '',
                PARENTID: '0',
                CHNLORDER: -1,
                DATAPATH: '',
                ROOTDOMAIN: '',
                IMGADDRESS: '',
                TEMPID: {
                    CHNLTEMPID: 0,
                    OTHERTEMPID: 0,
                    DOCTEMPID: 0,
                },
            };
            $scope.tempName = {
                channelTempName: '',
                otherTempName: '',
                articleTempName: '',
            };
            $scope.column = column;
            $scope.isChnlExist = '"false"'; //校验唯一标识是否已经存在
            $scope.savePos = 'true'; //校验存放位置是否已经存在
            if (!$scope.column.isColumn) { //频道 需要图片域名
                $scope.channel.IMGADDRESS = '';
            }
            initAllChannels();
        }

        function resetSize(str) {
            if (str === '') {
                $scope.picWidth = 16;
                $scope.picHeight = 9;
            } else {
                var strArr = str.split(',');
                if (strArr[0] === '' || strArr[0] === 'undefined' || strArr[1] === '' || strArr[1] === 'undefined') {
                    $scope.picWidth = 16;
                    $scope.picHeight = 9;
                } else {
                    $scope.picWidth = strArr[0];
                    $scope.picHeight = strArr[1];
                }
            }
        }

        function initAllChannels() {
            initManageConSelectedService.getWebsiteAllChannels($stateParams.site).then(function(data) {
                $scope.websiteChannelsJson = data;
                $scope.websiteChannelsJson.unshift({
                    name: '最前面',
                    value: -1,
                });
                $scope.selectedWebChannel = angular.copy($scope.websiteChannelsJson[0]);
                websiteChannel !== '' ? initEditData() : '';
            });
        }

        //获取前一级栏目
        $scope.querySelectChl = function() {
            $scope.channel.CHNLORDER = $scope.selectedWebChannel.value;
        };
        /**
         * [chnlOtherTemplate description]栏目其他模板点击
         * @return {[type]} [description]
         */
        $scope.chnlOtherTemplate = function() {
            queryTemplate(1, 'OTHERTEMPID', 'otherTempName');

        };
        /**
         * [chnlTemplate description]栏目模板点击
         * @return {[type]} [description]
         */
        $scope.chnlTemplate = function() {
            queryTemplate(1, 'CHNLTEMPID', 'channelTempName');
        };
        /**
         * [defaultArticleTemplate description]默认模板点击
         * @return {[type]} [description]
         */
        $scope.defaultArticleTemplate = function() {
            queryTemplate(2, 'DOCTEMPID', 'articleTempName');
        };

        /**
         * [queryTemplate description]模板弹窗打开
         * @param  {[type]} TEMPLATETYPE [description]
         * @return {[type]}              [description]
         */
        function queryTemplate(TEMPLATETYPE, ID, Name) {
            var params = {
                ObjectType: $scope.channel.OBJECTID > 0 ? '101' : '103',
                ObjectId: $scope.channel.OBJECTID > 0 ? $scope.channel.OBJECTID : $scope.channel.SITEID,
                TEMPLATETYPE: TEMPLATETYPE,
                TempName: '',
                selectedTempId: $scope.channel.TEMPID[ID],
                selectedTempName: $scope.tempName[Name],
            };
            productMangageMentWebsiteService.bindTemplate(params, function(result) {
                $scope.channel.TEMPID[ID] = result.TEMPID;
                $scope.tempName[Name] = result.TEMPNAME;
            });
        }
    }]);